import React from "react";

class GoodExample extends React.Component {

    render() {
        return <div className="GreenCode" onCopy={this.props.onCopy}>
            {this.props.children}
        </div>;
    }

}

export default GoodExample;
